import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "main-container" }
const _hoisted_2 = { class: "filter-container" }
const _hoisted_3 = { class: "action-list" }
const _hoisted_4 = { class: "logistics-detail" }
const _hoisted_5 = { class: "summary-box" }
const _hoisted_6 = { class: "logistics-timeline mt10" }
const _hoisted_7 = { class: "cities" }
const _hoisted_8 = {
  key: 0,
  class: "ml20"
}
const _hoisted_9 = ["innerHTML"]

import { getCurrentInstance, reactive, ref } from 'vue'
import { useRouter } from 'vue-router'
import Pagination from '@/components/Pagination.vue'
import { getAbnormalExpressOrderListApi } from '@/apis/order'
import SelectBrand from '@/components/SelectBrand.vue'
import { openRouteInNewWindow } from '@/utils/router-helper'
import { getLogisticsInfoApi } from '@/apis/others'
import Keys from '@/constant/key'
import { useStore } from '@/store/index'
import { joinParams } from '@/utils'
import { getBrandListApi } from '@/apis/brand'
import { BrandM } from '@/models/brand'


enum LogisticsStatus {
    '推送失败' = -1,
    '无物流轨迹' = 1,
    '问题件' = 5,
    '揽收失败'
}


export default /*@__PURE__*/_defineComponent({
  __name: 'AbnormalOrderList',
  setup(__props) {

const { proxy } = getCurrentInstance() as any
const store = useStore()

const filters = reactive({
    order_no:       '',     // 订单号
    name:           '',     // 收货人
    phone:          '',     // 手机号
    brand_name:     '',     // 品牌
    product_name:   '',     // 商品名称
    status:         '',     // 物流状态
    page_size:      10,     // 每页显示条数
    page:           1,      // 当前页码
})

const brandProps = {
    value: 'name',
    label: 'name'
}
const brandList = ref<any[]>([])
// 获取品牌列表
const getBrandList = async () =>{
    const {code, data, msg} = await getBrandListApi() as any
    brandList.value = data
}
getBrandList()

// 专题列表
const tableData = ref([])
const total = ref(0)
const getList = async () => {
    const { code, data, msg } = await getAbnormalExpressOrderListApi({ ...filters, admin_type: 1 }) as any
    if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
    tableData.value = data.data
    total.value = data.total
}
getList()

const previewList = ref<string[]>([])

// 跳转至编辑页
const toEdit = (id) => {
    openRouteInNewWindow({
        path: '/order/edit',
        query: {
            id
        }
    })
}

const logisticsDialogVisible = ref(false)
const currentLogistics = ref<any>({})
const logisticsTraces = reactive({
    fromCity: '',
    list: [] as any[]
})
const viewLogistics = async (row: any) => {
    const { express_cp, express_no, phone  } = row
    currentLogistics.value = row
    const res = await getLogisticsInfoApi(express_cp, express_no, phone) as any
    logisticsTraces.list = (res.Traces || []).reverse()
    if (logisticsTraces.list.length > 0) {
        logisticsTraces.fromCity = logisticsTraces.list[logisticsTraces.list.length - 1].Location
    }
    logisticsDialogVisible.value = true
}
// 格式化配送轨迹
const formatTrace = (station: string) => {
    return station.replace(/【/g, '<span class="color-weight">【').replace(/】/g, '】</span>')
}

const onExport = () => {
    window.open(`${Keys.baseUrl}/opsapi/getExpressUnusual?${joinParams({...filters, Access_token: store.state.user.userInfo.access_token, exportForCurrencyValue: 1})}`)
}

const onSearch = () => {
    filters.page = 1
    getList()
}
const onPageChange = (val) => {
    filters.page = val
    getList()
}
const onSizeChange = (val) => {
    filters.page_size = val
    getList()
}

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_select_v2 = _resolveComponent("el-select-v2")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_timeline_item = _resolveComponent("el-timeline-item")!
  const _component_el_timeline = _resolveComponent("el-timeline")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_input, {
        class: "filter-item",
        modelValue: filters.order_no,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((filters.order_no) = $event)),
        modelModifiers: { trim: true },
        placeholder: "订单号",
        clearable: ""
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_input, {
        class: "filter-item",
        modelValue: filters.name,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filters.name) = $event)),
        modelModifiers: { trim: true },
        placeholder: "收货人",
        clearable: ""
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_input, {
        class: "filter-item",
        modelValue: filters.phone,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((filters.phone) = $event)),
        modelModifiers: { trim: true },
        placeholder: "手机号",
        clearable: ""
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_select_v2, {
        class: "filter-item",
        modelValue: filters.brand_name,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((filters.brand_name) = $event)),
        placeholder: "请选择品牌",
        filterable: "",
        clearable: "",
        style: {"width":"200px"},
        props: brandProps,
        options: brandList.value
      }, null, 8, ["modelValue", "options"]),
      _createVNode(_component_el_input, {
        class: "filter-item",
        modelValue: filters.product_name,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((filters.product_name) = $event)),
        modelModifiers: { trim: true },
        placeholder: "商品名称",
        clearable: ""
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_select, {
        class: "filter-item",
        modelValue: filters.status,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((filters.status) = $event)),
        placeholder: "物流状态",
        clearable: "",
        filterable: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_option, {
            label: "推送失败",
            value: LogisticsStatus['推送失败']
          }, null, 8, ["value"]),
          _createVNode(_component_el_option, {
            label: "无物流轨迹",
            value: LogisticsStatus['无物流轨迹']
          }, null, 8, ["value"]),
          _createVNode(_component_el_option, {
            label: "问题件",
            value: LogisticsStatus['问题件']
          }, null, 8, ["value"]),
          _createVNode(_component_el_option, {
            label: "揽收失败",
            value: LogisticsStatus['揽收失败']
          }, null, 8, ["value"])
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_button, {
        class: "filter-btn",
        type: "primary",
        onClick: _cache[6] || (_cache[6] = ($event: any) => (onSearch()))
      }, {
        default: _withCtx(() => _cache[9] || (_cache[9] = [
          _createTextVNode("搜索")
        ])),
        _: 1
      }),
      _createVNode(_component_el_button, {
        class: "filter-btn",
        type: "primary",
        onClick: _cache[7] || (_cache[7] = ($event: any) => (onExport()))
      }, {
        default: _withCtx(() => _cache[10] || (_cache[10] = [
          _createTextVNode("导出")
        ])),
        _: 1
      })
    ]),
    _createVNode(_component_el_table, {
      data: tableData.value,
      border: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          prop: "order_id",
          label: "订单ID",
          width: "80"
        }),
        _createVNode(_component_el_table_column, {
          prop: "order_no",
          label: "订单号",
          width: "115"
        }),
        _createVNode(_component_el_table_column, {
          label: "商品图",
          width: "80"
        }, {
          default: _withCtx(({ row }) => [
            _createVNode(_component_el_image, {
              src: row.image_path,
              "preview-src-list": previewList.value = [row.image_path],
              class: "table-img"
            }, null, 8, ["src", "preview-src-list"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, { label: "商品信息" }, {
          default: _withCtx(({ row }) => [
            _createElementVNode("div", null, "品牌：" + _toDisplayString(row.brand_name), 1),
            _createElementVNode("div", null, "商品：" + _toDisplayString(row.product_name), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "收货人信息",
          width: "150"
        }, {
          default: _withCtx(({ row }) => [
            _createElementVNode("div", null, "收货人：" + _toDisplayString(row.name), 1),
            _createElementVNode("div", null, "手机号：" + _toDisplayString(row.phone), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, { label: "物流信息" }, {
          default: _withCtx(({ row }) => [
            _createElementVNode("div", null, "物流公司：" + _toDisplayString(row.express_name), 1),
            _createElementVNode("div", null, "物流单号：" + _toDisplayString(row.express_no), 1),
            _createElementVNode("div", null, "上传时间：" + _toDisplayString(row.created_at), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "物流状态",
          width: "85"
        }, {
          default: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(LogisticsStatus[row.status]), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "异常原因",
          prop: "reason"
        }),
        _createVNode(_component_el_table_column, {
          label: "操作",
          fixed: "right",
          width: "95"
        }, {
          default: _withCtx(({ row }) => [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_el_button, {
                type: "primary",
                size: "small",
                onClick: ($event: any) => (toEdit(row.order_id))
              }, {
                default: _withCtx(() => _cache[11] || (_cache[11] = [
                  _createTextVNode("订单详情")
                ])),
                _: 2
              }, 1032, ["onClick"]),
              _createVNode(_component_el_button, {
                type: "primary",
                size: "small",
                class: "mt10",
                onClick: ($event: any) => (viewLogistics(row))
              }, {
                default: _withCtx(() => _cache[12] || (_cache[12] = [
                  _createTextVNode("物流信息")
                ])),
                _: 2
              }, 1032, ["onClick"])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"]),
    _createVNode(Pagination, {
      total: total.value,
      currentPage: filters.page,
      onPageChange: onPageChange,
      onSizeChange: onSizeChange
    }, null, 8, ["total", "currentPage"]),
    _createVNode(_component_el_dialog, {
      modelValue: logisticsDialogVisible.value,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((logisticsDialogVisible).value = $event)),
      title: "物流信息",
      width: "800px"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_el_row, { gutter: 20 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 8 }, {
                  default: _withCtx(() => [
                    _createTextVNode("物流公司：" + _toDisplayString(currentLogistics.value.express_cp), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 8 }, {
                  default: _withCtx(() => [
                    _createTextVNode("物流单号：" + _toDisplayString(currentLogistics.value.express_no), 1)
                  ]),
                  _: 1
                }),
                (currentLogistics.value.ship_time)
                  ? (_openBlock(), _createBlock(_component_el_col, {
                      key: 0,
                      span: 8
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("单号上传时间：" + _toDisplayString(currentLogistics.value.ship_time), 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_el_row, { gutter: 20 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 8 }, {
                  default: _withCtx(() => [
                    _createTextVNode("收货人：" + _toDisplayString(currentLogistics.value.name), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 8 }, {
                  default: _withCtx(() => [
                    _createTextVNode("联系方式：" + _toDisplayString(currentLogistics.value.phone), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 8 }, {
                  default: _withCtx(() => [
                    _createTextVNode("下单时间：" + _toDisplayString(currentLogistics.value.created_at), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createTextVNode("收货地址：" + _toDisplayString(currentLogistics.value.province) + _toDisplayString(currentLogistics.value.city) + _toDisplayString(currentLogistics.value.area) + _toDisplayString(currentLogistics.value.addr), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            (currentLogistics.value.product_name)
              ? (_openBlock(), _createBlock(_component_el_row, { key: 0 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_col, { span: 24 }, {
                      default: _withCtx(() => [
                        _createTextVNode("商品信息：" + _toDisplayString(currentLogistics.value.product_name), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("span", null, "目的地：" + _toDisplayString(currentLogistics.value.city), 1),
              (logisticsTraces.fromCity)
                ? (_openBlock(), _createElementBlock("span", _hoisted_8, "始发地：" + _toDisplayString(logisticsTraces.fromCity), 1))
                : _createCommentVNode("", true)
            ]),
            _createVNode(_component_el_timeline, { class: "mt10" }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(logisticsTraces.list, (trace, index) => {
                  return (_openBlock(), _createBlock(_component_el_timeline_item, {
                    key: index,
                    timestamp: trace.AcceptTime
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", {
                        innerHTML: formatTrace(trace.AcceptStation)
                      }, null, 8, _hoisted_9)
                    ]),
                    _: 2
                  }, 1032, ["timestamp"]))
                }), 128))
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})